module.exports = __webpack_public_path__ + "img/room16.69bf0ba6.gif";